export const environment = {
    production: false,
    apiUrl: 'https://esg-qas.fundepag.br/api/backend',
    storagePrefix: 'fundepagESGQas'
  };
  